<div class="card">
  <div class="card-header text-center"><small><b>Available Configurations</b></small></div>
  <div class="card-body">
    <ng-container>
      <div class="d-flex flex-column w-100 border-bottom mb-2 bg-light p-3 border">
        <b class="border-bottom"><small>Filter Configurations</small></b>

        <div class="d-flex flex-wrap justify-content-between py-2">
          <div class="d-flex flex-column">
            <div class="d-flex mx-3 px-2 border-bottom"
                 *ngIf="configurationsWithoutFilter | showFittingFilter:{name: 'SpecialInspection'}">
              <input #magInspection [id]="'magInspection' + referrer" class="me-2" type="checkbox">
              <label
                     [for]="'magInspection'+ referrer">Mag Particle Insp.</label>
            </div>
            <div class="d-flex mx-3 px-2 border-bottom"
                 *ngIf="configurationsWithoutFilter | showFittingFilter:{name: 'ba'}">
              <input #buyAmerica [id]="'buyAmerica' + referrer" class="me-2" type="checkbox"> <label
                     [for]="'buyAmerica'+ referrer">Buy America</label>
            </div>
            <div class="d-flex mx-3 px-2 border-bottom"
                 *ngIf="configurationsWithoutFilter | showFittingFilter:{name: 'Lugs'}">
              <input #liftingLugs [id]="'liftingLugs' + referrer" class="me-2" type="checkbox">
              <label
                     [for]="'liftingLugs'+ referrer">Lifting Lugs</label>
            </div>

            <div class="d-flex flex-column mx-3 px-2 border-bottom border-top"
                 *ngIf="configurationsWithoutFilter | showFittingFilter:{name: 'TappedBlind'}">
              <span class="fs-5 mb-1">Tapped Holes</span>
              <div class="d-flex flex-column ms-3">
                <div class="d-flex" *ngFor="let opt of tappedHoleOptions">
                  <input type="checkbox" [value]="opt.text || ''"
                         (change)="dispatchTappedHolesChange({value: opt.text || '', status: $event})"><small
                         class="ms-2">{{opt.text}}</small>
                </div>
              </div>
            </div>

            <div class="d-flex flex-column mx-3 px-2 border-bottom border-top"
                 *ngIf="configurationsWithoutFilter | showFittingFilter:{name: 'ORing'}">
              <span class="fs-5 mb-1">O-Ring Options</span>
              <div class="d-flex flex-column">
                <div class="d-flex"
                     *ngFor="let opt of oringOptions">
                  <input type="checkbox" [value]="opt.text || ''"
                         (change)="dispatchOringChange({value: opt.text || '', status: $event})"><small
                         class="ms-2">{{opt.text}}</small>
                </div>
              </div>
            </div>

            <div class="d-flex flex-column mx-3 px-2 border-bottom border-top"
                 *ngIf="configurationsWithoutFilter | showFittingFilter:{name: 'Bevel'}">
              <span class="fs-5 mb-1">Bevel Options</span>
              <div class="d-flex flex-column">
                <div class="d-flex"
                     *ngFor="let opt of bevelOptions">
                  <input type="checkbox" [value]="opt.text || ''"
                         (change)="dispatchBevelChange({value: opt.text || '', status: $event})"><small
                         class="ms-2">{{opt.text}}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ul class="list-group list-group-flush" style="max-height: 20rem; overflow-y: auto;">
      <ng-template #noConfigs>
        <li class="list-group-item m-auto">There are no configurations available for this item.</li>
      </ng-template>

      <ng-container *ngIf="!configurationFilterIsApplied; else configurationFilterTempl">
        <li class="list-group-item py-1">
          <small>Select a filter to show configurations...</small>
        </li>
        <li class="text-end me-4 border-bottom"><small class="text-uppercase">{{configurationsWithoutFilter.length}}
            available configurations</small></li>
      </ng-container>
      <ng-template #configurationFilterTempl>
        <li class="list-group-item py-1 px-0" *ngFor="let configuration of configurations">
          <div class="d-flex justify-content-between">
            <div class="ms-2 me-auto">
              <div class="fw-bold"><small class="text-uppercase">{{partNumber + configuration.productLine +
                  configuration.suffix}}</small></div>
              <small>{{((configuration?.commercialDescription || '') === '' ? defaultDescription :
                configuration?.commercialDescription)}}</small>
            </div>
            <div class="ms-auto">
              <div class="d-flex flex-column">
                <!-- <span class="d-flex ms-auto">
                  <a class="ms-2 cursor-pointer text-decoration-none text-nowrap">
                    <small class="text-dark badge config-link py-1 pe-0">View Drawing</small>
                  </a>
                </span> -->

                <small class="d-flex ms-auto text-nowrap" *ngIf="!!configuration.leadTime"><span
                        class="ms-auto me-1">Lead Time:</span>{{configuration.leadTime}}</small>
                <small class="d-flex ms-auto text-nowrap" *ngIf="!!configuration.surge"><span
                        class="me-1">Surge:</span>
                  {{configuration.surge}}</small>
              </div>

            </div>
          </div>
        </li>
      </ng-template>

    </ul>

  </div>
</div>